module.exports = __webpack_public_path__ + "static/media/uit1.911b23d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/uit1.jpg
// module id = 5806
// module chunks = 0